import React, { useState, useEffect } from 'react'
import { Routes, Route, Navigate, useLocation, useNavigate } from 'react-router-dom'
//CSS
import styles from './Routes.module.css'

import evaluateStyles from './Evaluate/LandingPages.module.css'
//Components
import TabbedView from '../Components/Utils/TabbedView/TabbedView'
import { ITab } from '../Types/ITab'
import DevelopActive from './Develop/DevelopList'
import { useAppSelector, useAppDispatch } from '../Redux/Store/Store'
import { ImportQuestionnaireTemplate } from '../API/TemplateBank/TemplateBank'
import Popup from '../Components/Utils/Popup/Popup'
import ImportTemplate from '../Components/Products/ImportTemplate/ImportTemplate'
import { getClient } from '../Redux/Store/Slices/client'
import { ProductType } from '../Types/ProductType'
import { setQuestionnaire } from '../Redux/Store/Slices/questionnaire'

const tabs: ITab[] = [
  {
    title: "Active",
    active: true,
    url: "/develop/active"
  },
  {
    title: "Archive",
    active: false,
    url: "/develop/archive"
  }
]

const Develop = () => {

  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  
  const [showImportTemplate, setShowImportTemplate] = useState<boolean>(false);
  const location = useLocation();
  const [activeTab, setActiveTab] = useState<ITab>(tabs[0]);

  const client = useAppSelector(getClient);

  useEffect(() => {
    const selectedTab = tabs.find((tab) => location.pathname.startsWith(tab.url));

    if (selectedTab && selectedTab.title !== activeTab.title) {
      setActiveTab(selectedTab);
    }
  }, [location.pathname, activeTab.title]);

  const handleImportTemplate = (templateId: string, observee?: string, departmentId?: string, partnerId?: string, groupIds?: string[]) => {
    const importTemplate = async () => {
      if(client){
        // TODO: Replace with actual Develop import API when available
        // For now, using Evaluate import as placeholder
        const questionnaire = await ImportQuestionnaireTemplate(templateId, client.id, departmentId, partnerId, groupIds, observee);
        dispatch(setQuestionnaire(questionnaire));  
        // Navigate to the area route using the questionnaire ID as the areaId
        navigate(`/develop/${questionnaire.id}`);
      }
    }
    return importTemplate();
  }

  return (
    <div className={styles.container}>
      <div className={evaluateStyles.header}>
        <h3>Develop</h3>
        <TabbedView data={tabs} activeTab={activeTab} activeTabChanged={setActiveTab} />
      </div>
      
      <div className={styles.body}>
        <Routes>
          <Route index element={<Navigate to="active" replace />} />
          <Route path="active" element={<DevelopActive setShowImportTemplate={setShowImportTemplate} archived={false} />} />
          <Route path="archive" element={<DevelopActive setShowImportTemplate={setShowImportTemplate} archived={true} />} />
        </Routes>
      </div>

      <Popup  isVisible={showImportTemplate} onClose={() => setShowImportTemplate(!showImportTemplate)}>
          <ImportTemplate importHandler={handleImportTemplate} productType={ProductType.Develop} />
      </Popup>
    </div>
  )
}

export default Develop